import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios, { FILE_URL } from '../../api/axios';
import AdminLayout from '../../layouts/AdminLayout';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaTrash, FaTh, FaList } from 'react-icons/fa';

const Favorites = () => {
    const { t } = useTranslation();
    const [favorites, setFavorites] = useState([]);
    const [viewMode, setViewMode] = useState('grid'); // 'grid' veya 'list'

    const fetchFavorites = async () => {
        try {
            const res = await axios.get('/favorites');
            setFavorites(res.data);
        } catch (error) {
            console.error('Favoriler yüklenemedi');
        }
    };

    useEffect(() => {
        fetchFavorites();
    }, []);

    const handleRemoveFavorite = async (productId) => {
        try {
            await axios.post('/favorites/toggle', { productId });
            toast.success(t('messages.product_deleted'));
            fetchFavorites(); // Listeyi güncelle
        } catch (error) {
            toast.error(t('messages.error_occurred'));
        }
    };

    return (
        <AdminLayout>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="m-0">{t('favorites.title')}</h2>
                <div className="btn-group">
                    <button 
                        className={`btn ${viewMode === 'grid' ? 'btn-primary' : 'btn-outline-secondary'}`} 
                        onClick={() => setViewMode('grid')}
                        title={t('favorites.grid_view')}
                    >
                        <FaTh />
                    </button>
                    <button 
                        className={`btn ${viewMode === 'list' ? 'btn-primary' : 'btn-outline-secondary'}`} 
                        onClick={() => setViewMode('list')}
                        title={t('favorites.list_view')}
                    >
                        <FaList />
                    </button>
                </div>
            </div>
            
            {favorites.length === 0 ? (
                <div className="alert alert-info">{t('favorites.empty')}</div>
            ) : (
                <div className="row">
                    {favorites.map(product => (
                        viewMode === 'grid' ? (
                            <div key={product.id} className="col-sm-6 col-lg-3 mb-4">
                                <div className="card h-100 shadow-sm border-0 transition-hover">
                                    <div style={{ position: 'relative' }}>
                                        <Link to={`/products/${product.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <div style={{ height: '220px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                                                {product.main_image ? (
                                                <img src={`${FILE_URL}/${product.main_image}`} className="card-img-top" alt={product.name} style={{ maxHeight: '100%', width: 'auto' }} />
                                                ) : (
                                                    <span className="text-muted">{t('favorites.no_image')}</span>
                                                )}
                                            </div>
                                        </Link>
                                        <button 
                                            className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2 rounded-circle shadow-sm d-flex align-items-center justify-content-center"
                                            style={{ width: '35px', height: '35px', zIndex: 5 }}
                                            onClick={() => handleRemoveFavorite(product.id)}
                                            title={t('favorites.remove')}
                                        >
                                            <FaTrash size={14} />
                                        </button>
                                    </div>
                                    <div className="card-body d-flex flex-column">
                                        <Link to={`/products/${product.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                            <h6 className="card-title fw-bold text-truncate mb-1" title={product.name}>{product.name}</h6>
                                        </Link>
                                        <div className="mt-auto pt-3">
                                            <Link to={`/products/${product.id}`} className="btn btn-outline-primary w-100 btn-sm rounded-pill">
                                                {t('favorites.inspect')}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div key={product.id} className="col-12 mb-3">
                                <div className="card shadow-sm border-0 transition-hover">
                                    <div className="row g-0 align-items-center">
                                        <div className="col-md-2" style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa' }}>
                                            <Link to={`/products/${product.id}`} style={{ textDecoration: 'none', color: 'inherit', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {product.main_image ? (
                                                    <img src={`${FILE_URL}/${product.main_image}`} alt={product.name} style={{ maxHeight: '90%', maxWidth: '90%', objectFit: 'contain' }} />
                                                ) : (
                                                    <span className="text-muted small">{t('favorites.no_image')}</span>
                                                )}
                                            </Link>
                                        </div>
                                        <div className="col-md-8">
                                            <div className="card-body">
                                                <Link to={`/products/${product.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                    <h5 className="card-title fw-bold mb-1">{product.name}</h5>
                                                </Link>
                                                <p className="text-muted small mb-0">
                                                    {product.unit_type === 'm2' ? t('common.unit_m2') : product.unit_type === 'pallet' ? t('common.unit_pallet') : t('common.unit_piece')}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-2 p-3 text-end d-flex flex-column gap-2 justify-content-center">
                                            <Link to={`/products/${product.id}`} className="btn btn-outline-primary btn-sm rounded-pill">
                                                {t('favorites.inspect')}
                                            </Link>
                                            <button 
                                                className="btn btn-outline-danger btn-sm rounded-pill"
                                                onClick={() => handleRemoveFavorite(product.id)}
                                            >
                                                <FaTrash className="me-1" /> {t('favorites.remove_btn')}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    ))}
                </div>
            )}
        </AdminLayout>
    );
};

export default Favorites;
